import script from "./KubectlShell.vue?vue&type=script&lang=js"
export * from "./KubectlShell.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__